import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalOrderDetailPage } from './modal-order-detail.page';

const routes: Routes = [
  {
    path: '',
    component: ModalOrderDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalOrderDetailPageRoutingModule {}
